module.exports = __webpack_public_path__ + "static/media/icon_open_workspace.8717d8aa.svg";